import React from "react";

import _ from "lodash";

import { Link } from "react-router";

import { formatDate } from "../lib/formatters";

import { Subscribe } from "unstated";

import { SalesHistoryContainer } from "./containers/sales-history-container";

import { from } from "rxjs";
import { startWith } from "rxjs/operators";
import { useObservable } from "rxjs-hooks";

const navigateOrderDetail = (orderId) => `/account/profile/orders/${orderId}`;

const renderOrderDetail = (order, i) => (
  <React.Fragment key={i}>
    {order.deliveryComplete && (
      <div className="row p-1">
        <div className="col-sm-6">Delivered On:</div>
        <div className="col-sm-6">
          {formatDate(order.customerSignature.customerSignatureDate)}
        </div>
      </div>
    )}

    <div className="row p-1">
      <div className="col-sm-6">Shipped to:</div>
      <div className="col-sm-6">{order.customerName}</div>
    </div>

    <div className="row p-1 mb-4">
      <div className="col-sm-6">Order Number:</div>
      <div className="col-sm-6">
        {order.saleID} |{" "}
        <Link className="link" to={navigateOrderDetail(order.saleID)}>
          VIEW
        </Link>
      </div>
    </div>
  </React.Fragment>
);

const OrderHistoryView = ({ salesHistoryContainer }) => {
  const salesHistory = useObservable(() =>
    from(salesHistoryContainer.all()).pipe(startWith([]))
  );

  return (
    <div className="container-fluid">
      <h3 className="text-center">Orders</h3>

      <hr className="mt-4 mb-3" />

      {_.map(salesHistory, renderOrderDetail)}
    </div>
  );
};

const OrderHistory = () => (
  <Subscribe to={[SalesHistoryContainer]}>
    {(salesHistoryContainer) => (
      <OrderHistoryView salesHistoryContainer={salesHistoryContainer} />
    )}
  </Subscribe>
);

export { OrderHistory };
